import { style } from '@vanilla-extract/css'

import { subhead } from '../../nft/css/common.css'
import { breakpoints, sprinkles } from '../../nft/css/sprinkles.css'
import { colors } from '../../theme/colors'

export const logoContainer = style([
  sprinkles({
    display: 'flex',
    marginRight: '12',
    alignItems: 'center',
    cursor: 'pointer',
  }),
])

export const logo = style([
  sprinkles({
    display: 'flex',
    alignItems: 'center',
  }),
])

export const logoTitle = style([
  {
    paddingLeft: '8px',
    color: '#E0E0E0',
    fontSize: '18px',
    fontWeight: '600',
    lineHeight: '20px',
    letterSpacing: '-0.03em',

    '@media': {
      [`screen and (max-width: ${breakpoints.md}px)`]: {
        display: 'none',
      },
    },
  },
])

export const baseSideContainer = style([
  sprinkles({
    display: 'flex',
    width: 'full',
    flex: '1',
    flexShrink: '2',
  }),
])

export const leftSideContainer = style([
  baseSideContainer,
  sprinkles({
    alignItems: 'center',
    justifyContent: 'flex-start',
  }),
  {
    '@media': {
      [`screen and (min-width: ${breakpoints.md}px)`]: {
        gap: '31px',
      },
    },
  },
])

export const searchContainer = style([
  sprinkles({
    flex: '1',
    flexShrink: '1',
    marginX: '16',
    justifyContent: { lg: 'flex-end', xl: 'center' },
    display: { sm: 'none', navSearchInputVisible: 'flex' },
    alignSelf: 'center',
    height: '48',
    alignItems: 'flex-start',
  }),
])

export const rightSideContainer = style([
  baseSideContainer,
  sprinkles({
    alignItems: 'center',
    justifyContent: 'flex-end',
  }),
])

const baseMenuItem = style([
  subhead,
  sprinkles({
    padding: '8',
    marginY: '4',
    borderRadius: '8',
    transition: '250',
    height: 'min',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4',
  }),
  {
    lineHeight: '16px',
    textDecoration: 'none',
    ':hover': {
      // background: vars.color.lightGrayOverlay,
      color: colors.accent,
    },
  },
])

export const menuItem = style([
  baseMenuItem,
  {
    color: colors.gray400,
  },
])

export const activeMenuItem = style([
  baseMenuItem,
  sprinkles({
    background: 'backgroundFloating',
  }),
  {
    color: colors.accent,
    fontWeight: 600,
  },
])
